module.exports = __webpack_public_path__ + "img/product-3.5531cfd1.png";